"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var apollo_client_1 = require("apollo-client");
var ApolloOperationError = /** @class */ (function (_super) {
    __extends(ApolloOperationError, _super);
    function ApolloOperationError(apolloError, doc, variables) {
        if (variables === void 0) { variables = {}; }
        var _this = _super.call(this, apolloError ? __assign({}, apolloError) : {}) || this;
        _this.operationDoc = doc;
        _this.operationVariables = variables;
        return _this;
    }
    Object.defineProperty(ApolloOperationError.prototype, "operationDefinition", {
        get: function () {
            return this.operationDoc.definitions.find(function (definition) {
                return definition.kind === 'OperationDefinition' &&
                    definition.name !== undefined;
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ApolloOperationError.prototype, "operationName", {
        get: function () {
            if (this.operationDefinition && this.operationDefinition.name) {
                return this.operationDefinition.name.value;
            }
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ApolloOperationError.prototype, "operationType", {
        get: function () {
            if (this.operationDefinition && this.operationDefinition.name) {
                return this.operationDefinition.operation;
            }
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    return ApolloOperationError;
}(apollo_client_1.ApolloError));
exports.ApolloOperationError = ApolloOperationError;
function isOperationError(err) {
    return (err.hasOwnProperty('operationDoc') &&
        err.hasOwnProperty('operationVariables'));
}
exports.isOperationError = isOperationError;
function isQueryError(err) {
    return isOperationError(err) && err.operationType === 'query';
}
exports.isQueryError = isQueryError;
function isMutationError(err) {
    return isOperationError(err) && err.operationType === 'mutation';
}
exports.isMutationError = isMutationError;
function isSubscriptionError(err) {
    return isOperationError(err) && err.operationType === 'subscription';
}
exports.isSubscriptionError = isSubscriptionError;
//# sourceMappingURL=ApolloOperationError.js.map